import { render, staticRenderFns } from "./ViewMedicalInformationDialog.vue?vue&type=template&id=1a050047&scoped=true"
import script from "./ViewMedicalInformationDialog.vue?vue&type=script&lang=js"
export * from "./ViewMedicalInformationDialog.vue?vue&type=script&lang=js"
import style0 from "./ViewMedicalInformationDialog.vue?vue&type=style&index=0&id=1a050047&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a050047",
  null
  
)

export default component.exports